const usTimezones = [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Adak",
    "Pacific/Honolulu"
];

function isUSTimezone() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return usTimezones.includes(userTimezone);
}

function getVariantId() {

    const inputElement = document.querySelector(".store-availability-container__wrapper")
    if (inputElement) {
        const value = inputElement.getAttribute('data-variant-id');
        if (value) {
            console.log("Value: ", value)
            sendHTTPRequest(value);
        } else {
            setTimeout(() => {
                handleVariantChange();
            }, 500);
        }
    } else {
        console.log("Element not found");
        setTimeout(() => {
            handleVariantChange();
        }, 500);
    }
}

// 创建库存信息元素的函数
function createInventoryElement(data) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("Inventory-quantity");
    const newSpan = document.createElement("span");
    const newI = document.createElement("i");
    if (data > 10) {
        newSpan.textContent = "Available in U.S. warehouse – ready to ship FREE!";
        newI.classList.add("safe");
    } else if (data >= 1) {
        const dataSpan = document.createElement('span');
        dataSpan.textContent = data;
        dataSpan.style.color = '#F2733A';
        dataSpan.style.fontWeight = "bold";
        newSpan.appendChild(document.createTextNode('Only '));
        newSpan.appendChild(dataSpan);
        newSpan.appendChild(document.createTextNode('  left in U.S. warehouse – FREE & fast domestic shipping!'));
        newI.classList.add("danger");
    }
    newDiv.appendChild(newI);
    newDiv.appendChild(newSpan);
    return newDiv;
}

async function sendHTTPRequest(variantId) {
    try {
        const response = await fetch(`https://api.fullshine.net?variantId=${variantId}`);
        const data = await response.json();
        console.log("request data: ", data)
        const existingInventoryQuantity = document.querySelector('.Inventory-quantity');
        if (existingInventoryQuantity) {
            existingInventoryQuantity.remove();
        }
        const targetElement = document.querySelector('.product__controls-group-quantity')
        if (targetElement) {

          // 使用 window.matchMedia 检测屏幕宽度是否大于 750px
          const mediaQuery = window.matchMedia('(min-width: 750px)');
          // 定义一个函数来处理样式设置
          function setStyles() {
              if (mediaQuery.matches) {
                  // 当屏幕宽度大于 750px 时设置样式
                  targetElement.style.display = 'flex';
                  targetElement.style.justifyContent = 'flex-start';
                  targetElement.style.alignItems = "center";
              } else {
                  // 当屏幕宽度小于等于 750px 时移除样式（可选）
                  targetElement.style.display = '';
                  targetElement.style.justifyContent = '';
                  targetElement.style.alignItems = '';
              }
          }
          // 初始调用函数以设置初始样式
          setStyles();
          // 监听媒体查询的变化，当屏幕宽度改变时重新设置样式
          mediaQuery.addEventListener('change', setStyles);
          let newBox = targetElement.querySelector('.Out-box');
          if (!newBox) {
              // 创建新的包裹盒子
              newBox = document.createElement("div");
              newBox.classList.add('Out-box');
      
              // 获取需要包裹的元素
              const quantityText = document.querySelector(".product__controls-group-quantity .product__label-wrapper");
              const quantityBotton = document.querySelector(".product__controls-group-quantity .product__item");
      
              // 将元素添加到新盒子中
              newBox.appendChild(quantityText);
              newBox.appendChild(quantityBotton);
      
              // 将新盒子插入到目标元素中，与 Inventory-quantity 同级
              targetElement.insertBefore(newBox, targetElement.firstChild);
          }

         
          
          
          const newDiv = document.createElement("div");
          newDiv.classList.add("Inventory-quantity");
          const newSpan = document.createElement("span");
          const newI = document.createElement("i")
          if (data > 10) {
              newSpan.textContent = "Available in U.S. warehouse – ready to ship FREE!";
              newI.classList.add("safe");
          } else if (data >= 1) {
              // 创建一个新的 span 元素来包裹 data
              const dataSpan = document.createElement('span');
              dataSpan.textContent = data;
              dataSpan.style.color = '#FF6C11';
              dataSpan.style.fontWeight = "bold"
  
              // 拼接文本内容
              newSpan.appendChild(document.createTextNode('Only '));
              newSpan.appendChild(dataSpan);
              newSpan.appendChild(document.createTextNode('  left in U.S. warehouse – FREE & fast domestic shipping!'));
              newI.classList.add("danger");
          }
          newDiv.appendChild(newI);
          newDiv.appendChild(newSpan);

          targetElement.appendChild(newDiv);
      }
    } catch (error) {
        console.error('Fetch error:', error);
    }
}

async function handleVariantChange() {
    if (!isUSTimezone()) {
        console.log('The user is not in the US and does not perform follow-up actions');
        return;
    }
    await getVariantId();
}

handleVariantChange();
const targetElementClick = document.querySelector('.store-availability-container__wrapper');

if (targetElementClick) {
    // 创建一个 MutationObserver 实例
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-variant-id') {
                // 当 data-variant-id 属性发生变化时执行相应操作
                const newVariantId = targetElementClick.dataset.variantId;
                // 在这里调用你的处理函数
                handleVariantChange();
            }
        }
    });

    // 配置观察选项，这里只观察属性变化，并且指定要观察的属性为 data-variant-id
    const config = { attributes: true, attributeFilter: ['data-variant-id'] };

    // 开始观察目标元素
    observer.observe(targetElementClick, config);
}